var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar'),_c('div',{staticClass:"container mt-6"},[_c('LayoutHeader',{attrs:{"title":"Privacy Notice","subtitle":""}})],1),_c('div',{staticClass:"container"},[_c('div',{staticClass:"section"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.privacy)}})])]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }